import { styled, Typography } from "@mui/material";
import React from "react";

interface ErrorProps {
    text: string;
}

const Error: React.FunctionComponent<ErrorProps> = ({ text }) => (
    <Wrapper>
        <Typography style={{ marginTop: 20, textAlign: "center" }}>{text}</Typography>
    </Wrapper>
);

export default Error;

export const Wrapper = styled("div")`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;
